<script>
/*jshint esversion: 6 */
export default {
    name: 'PreviewField',
    props: { 
        'disabled': {type: Boolean},
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
		'hinted': {type:String},
    }
};
</script>
<template lang="pug">
.vueFormFieldMain(:class="schema.class")
    .fieldPreview(:id="schema.id")
        .col-sm-12
            .previewBox(v-html="model[schema.model]")
        .row.fieldInput.col-12
            .hint(v-if="hinted && hinted.length > 0" v-html="hinted")
</template>